export default __webpack_public_path__ + "static/media/13.5824eb64.PNG";